import DisabledOffers from "./DisabledOffers";

export default DisabledOffers;